import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { equipmentListFilterFields } from '@/features/equipment/equipmentListFilterFields';
export const EquipmentSearchSchema = z.object({
  ...dataGridSearchFields,
  freeText: z.string().optional(),
  equipmentTypeIdIn: equipmentListFilterFields.equipmentTypeIdIn,
  equipmentItemIdIn: equipmentListFilterFields.equipmentItemIdIn,
  itemTypeIn: equipmentListFilterFields.itemTypeIn
});
export type EquipmentSearch = z.infer<typeof EquipmentSearchSchema>;